(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-compare"] && !Shopify.designMode) return;
  try {
    
  class CompareTool extends HTMLElement {
    connectedCallback() {
      this.#cards = Array.from(this.querySelectorAll('compare-card'));
      this.#checkboxes = Array.from(this.querySelectorAll('[data-model-checkbox]'));
      this.#emptyState = this.querySelector('[data-empty-state]');
      this.#filterLabel = this.querySelector('[data-filter-label]');
      this.#swimlane = this.querySelector('[data-swimlane]');
      this.#clearSessionBtn = this.querySelector('[data-clear-session]');
      this.#selectAllBtn = this.querySelector('[data-select-all]');
      this.#clearAllBtn = this.querySelector('[data-clear-all]');
      this.#filterToggle = this.querySelector('[data-filter-toggle]');
      this.#dropdown = this.querySelector('.custom-compare__dropdown');
      this.#scrollPrevBtn = this.querySelector('[data-scroll-prev]');
      this.#scrollNextBtn = this.querySelector('[data-scroll-next]');

      this.#allModelIds = this.#cards.map((c) => c.getAttribute('data-model-id'));
      this.#checkboxes = this.#checkboxes.filter((checkbox) => {
        if (this.#allModelIds.includes(checkbox.value)) {
          return true;
        }

        checkbox.closest('.custom-compare__dropdown-row')?.remove();
        return false;
      });
      const params = new URLSearchParams(window.location.search);
      const preload = params.get('models');

      if (preload) {
        this.#visibleIds = new Set(preload.split(',').filter((id) => this.#allModelIds.includes(id)));
      } else {
        const sessionModels = this.#getSessionModels();
        if (sessionModels.length > 0) {
          this.#visibleIds = new Set(sessionModels.filter((id) => this.#allModelIds.includes(id)));
        } else {
          this.#visibleIds = new Set(this.#allModelIds);
        }
      }

      this.#render();

      for (const cb of this.#checkboxes) {
        cb.addEventListener('change', () => {
          const id = cb.value;
          if (cb.checked) {
            this.#visibleIds.add(id);
          } else {
            this.#visibleIds.delete(id);
          }
          this.#render();
        });
      }

      this.addEventListener('compare:close', (e) => {
        const { modelId } = e.detail;
        this.#visibleIds.delete(modelId);
        this.#render();
      });

      if (this.#selectAllBtn) {
        this.#selectAllBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.#visibleIds = new Set(this.#allModelIds);
          this.#render();
        });
      }

      if (this.#clearAllBtn) {
        this.#clearAllBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.#visibleIds.clear();
          this.#render();
        });
      }

      if (this.#clearSessionBtn) {
        this.#clearSessionBtn.addEventListener('click', () => {
          this.#clearSessionModels();
          this.#clearSessionBtn.hidden = true;
          this.#visibleIds = new Set(this.#allModelIds);
          this.#render();
        });
      }

      this.#updateSessionButton();

      window.addEventListener('compareListUpdated', () => {
        this.#updateSessionButton();
      });

      if (this.#filterToggle && this.#dropdown) {
        this.#filterToggle.addEventListener('click', () => this.#toggleDropdown());

        this.#boundClickOutside = (e) => {
          if (!this.#dropdown.contains(e.target) && e.target !== this.#filterToggle && !this.#filterToggle.contains(e.target)) {
            this.#closeDropdown();
          }
        };

        this.#boundEscape = (e) => {
          if (e.key === 'Escape') this.#closeDropdown();
        };
      }

      if (this.#scrollPrevBtn) {
        this.#scrollPrevBtn.addEventListener('click', () => this.#scrollByCard(-1));
      }
      if (this.#scrollNextBtn) {
        this.#scrollNextBtn.addEventListener('click', () => this.#scrollByCard(1));
      }
      if (this.#swimlane) {
        this.#boundScroll = () => this.#updateScrollButtons();
        this.#swimlane.addEventListener('scroll', this.#boundScroll, { passive: true });
        window.addEventListener('resize', this.#boundScroll);
      }
      this.#updateScrollButtons();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.#boundClickOutside);
      document.removeEventListener('keydown', this.#boundEscape);
      if (this.#swimlane && this.#boundScroll) {
        this.#swimlane.removeEventListener('scroll', this.#boundScroll);
        window.removeEventListener('resize', this.#boundScroll);
      }
    }

    #scrollByCard(direction) {
      if (!this.#swimlane) return;
      const firstCard = this.#swimlane.querySelector('compare-card:not([hidden])');
      const step = firstCard ? firstCard.offsetWidth : Math.round(this.#swimlane.clientWidth * 0.8);
      this.#swimlane.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    #updateScrollButtons() {
      if (!this.#swimlane || !this.#scrollPrevBtn || !this.#scrollNextBtn) return;
      const maxScroll = this.#swimlane.scrollWidth - this.#swimlane.clientWidth;
      const hasOverflow = maxScroll > 1;
      this.#scrollPrevBtn.hidden = !hasOverflow;
      this.#scrollNextBtn.hidden = !hasOverflow;
      if (!hasOverflow) return;
      const left = this.#swimlane.scrollLeft;
      this.#scrollPrevBtn.disabled = left <= 1;
      this.#scrollNextBtn.disabled = left >= maxScroll - 1;
    }

    #toggleDropdown() {
      if (this.#dropdown.hidden) {
        this.#dropdown.hidden = false;
        this.#filterToggle.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this.#boundClickOutside);
        document.addEventListener('keydown', this.#boundEscape);
      } else {
        this.#closeDropdown();
      }
    }

    #closeDropdown() {
      this.#dropdown.hidden = true;
      this.#filterToggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.#boundClickOutside);
      document.removeEventListener('keydown', this.#boundEscape);
    }

    #render() {
      for (const card of this.#cards) {
        const id = card.getAttribute('data-model-id');
        card.hidden = !this.#visibleIds.has(id);
      }

      for (const cb of this.#checkboxes) {
        cb.checked = this.#visibleIds.has(cb.value);
      }

      const count = this.#visibleIds.size;
      if (this.#filterLabel) {
        this.#filterLabel.textContent = count > 0
          ? count + ' Model' + (count !== 1 ? 's' : '') + ' Selected'
          : 'Filter Models';
      }

      if (this.#emptyState) {
        this.#emptyState.hidden = count > 0;
      }

      if (this.#swimlane) {
        this.#swimlane.hidden = count === 0;
      }

      this.#updateScrollButtons();
      this.#updateUrl();
    }

    #updateUrl() {
      const url = new URL(window.location);
      if (this.#visibleIds.size === this.#allModelIds.length || this.#visibleIds.size === 0) {
        url.searchParams.delete('models');
      } else {
        url.searchParams.set('models', Array.from(this.#visibleIds).join(','));
      }
      history.replaceState(null, '', url);
    }

    #getSessionModels() {
      try {
        const stored = sessionStorage.getItem('compareModels');
        return stored ? JSON.parse(stored) : [];
      } catch (err) {
        return [];
      }
    }

    #clearSessionModels() {
      sessionStorage.removeItem('compareModels');
      window.dispatchEvent(new Event('compareListUpdated'));
    }

    #updateSessionButton() {
      if (!this.#clearSessionBtn) return;
      const models = this.#getSessionModels();
      this.#clearSessionBtn.hidden = models.length === 0;
    }

    #cards;
    #checkboxes;
    #emptyState;
    #filterLabel;
    #swimlane;
    #clearSessionBtn;
    #selectAllBtn;
    #clearAllBtn;
    #filterToggle;
    #dropdown;
    #scrollPrevBtn;
    #scrollNextBtn;
    #allModelIds;
    #visibleIds;
    #boundClickOutside;
    #boundEscape;
    #boundScroll;
  }

  if (!customElements.get('compare-tool')) {
    customElements.define('compare-tool', CompareTool);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-ski-finder"] && !Shopify.designMode) return;
  try {
    
  class SkiFinder extends HTMLElement {
    connectedCallback() {
      this.#mode = this.dataset.mode || 'full';
      this.#resultsUrl = this.dataset.resultsUrl || '/pages/ski-finder';
      this.#klaviyoList = this.dataset.klaviyoList || '';

      /* DOM refs */
      this.#quizView = this.querySelector('[ref="quizView"]');
      this.#resultsView = this.querySelector('[ref="resultsView"]');
      this.#previousBanner = this.querySelector('[ref="previousBanner"]');
      this.#stepContainer = this.querySelector('[ref="stepContainer"]');
      this.#progressText = this.querySelector('[ref="progressText"]');
      this.#backBtn = this.querySelector('[ref="backBtn"]');
      this.#nextBtn = this.querySelector('[ref="nextBtn"]');
      this.#restartBtn = this.querySelector('[ref="restartBtn"]');
      this.#resultsRestartBtn = this.querySelector('[ref="resultsRestartBtn"]');

      /* Button listeners */
      this.#backBtn?.addEventListener('click', () => this.#goBack());
      this.#nextBtn?.addEventListener('click', () => this.#goNext());
      this.#restartBtn?.addEventListener('click', () => this.#restart());
      this.#resultsRestartBtn?.addEventListener('click', () => this.#restart());

      /* Load data from JSON asset */
      const dataEl = this.querySelector('[ref="finderData"]');
      const dataSrc = dataEl?.dataset?.src;

      if (dataSrc) {
        fetch(dataSrc)
          .then((r) => r.json())
          .then((d) => {
            this.#data = d;
            this.#init();
          })
          .catch(() => {
            if (dataEl?.textContent?.trim()) {
              try {
                this.#data = JSON.parse(dataEl.textContent);
                this.#init();
              } catch { /* no data available */ }
            }
          });
      } else if (dataEl?.textContent?.trim()) {
        try {
          this.#data = JSON.parse(dataEl.textContent);
          this.#init();
        } catch { /* no data available */ }
      }
    }

    /* ══════════════════════════════════════
       Init — called after data is loaded
       ══════════════════════════════════════ */
    #init() {
      this.#totalSteps = this.#data.questions.length + 1;

      /* Check for previous answers in localStorage */
      try {
        const saved = localStorage.getItem('finder');
        if (saved) {
          this.#answers = JSON.parse(saved);

          const bio = localStorage.getItem('bio');
          if (bio) this.#formValues = JSON.parse(bio);

          const prefs = localStorage.getItem('skiprefs');
          if (prefs) {
            const p = JSON.parse(prefs);
            this.#sizeResult = p.recommended || 0;
          }

          this.#recommendation = this.#getRecommendations(this.#answers);
          this.#syncLiveChat();

          if (this.#mode === 'portable') {
            this.#showPreviousBanner();
            return;
          }

          /* Full mode — jump straight to results */
          this.#recommendation = this.#getRecommendations(this.#answers);
          this.#showResults();
          return;
        }
      } catch { /* no saved data, continue to quiz */ }

      this.#renderStep();
    }

    /* ══════════════════════════════════════
       State
       ══════════════════════════════════════ */
    #data;
    #mode;
    #resultsUrl;
    #klaviyoList;
    #currentStep = 0;
    #totalSteps;
    #answers = {};
    #formValues = {};
    #recommendation = [];
    #sizeResult = 0;
    #modelProducts;

    /* ══════════════════════════════════════
       DOM Refs
       ══════════════════════════════════════ */
    #quizView;
    #resultsView;
    #previousBanner;
    #stepContainer;
    #progressText;
    #backBtn;
    #nextBtn;
    #restartBtn;
    #resultsRestartBtn;

    /* ══════════════════════════════════════
       Navigation
       ══════════════════════════════════════ */
    #goBack() {
      if (this.#currentStep > 0) {
        this.#currentStep--;
        this.#renderStep();
      }
    }

    #goNext() {
      if (this.#currentStep < this.#totalSteps - 1) {
        this.#currentStep++;
        this.#renderStep();
      }
    }

    #restart() {
      this.#answers = {};
      this.#formValues = {};
      this.#recommendation = [];
      this.#sizeResult = 0;
      this.#currentStep = 0;

      try {
        localStorage.removeItem('finder');
        localStorage.removeItem('bio');
        localStorage.removeItem('skiprefs');
        localStorage.removeItem('recommended');
      } catch { /* noop */ }

      this.#syncLiveChat();

      if (this.#previousBanner) this.#previousBanner.hidden = true;
      if (this.#resultsView) this.#resultsView.hidden = true;
      if (this.#quizView) this.#quizView.hidden = false;

      this.#renderStep();
    }

    /* ══════════════════════════════════════
       Step Rendering
       ══════════════════════════════════════ */
    #renderStep() {
      if (!this.#stepContainer) return;

      const isForm = this.#currentStep >= this.#data.questions.length;
      const stepNum = this.#currentStep + 1;

      /* Progress text */
      if (this.#progressText) {
        this.#progressText.textContent =
          'Question ' + stepNum + ' of ' + this.#totalSteps;
      }

      /* Back button visibility */
      if (this.#backBtn) {
        this.#backBtn.hidden = this.#currentStep === 0;
      }

      /* Bio form step (last step) */
      if (isForm) {
        this.#renderBioForm();
        if (this.#nextBtn) this.#nextBtn.hidden = true;
        return;
      }

      /* Question steps */
      const q = this.#data.questions[this.#currentStep];
      const hasAnswer = this.#answers[this.#currentStep] !== undefined;

      if (this.#nextBtn) {
        this.#nextBtn.hidden = false;
        this.#nextBtn.disabled = !hasAnswer;
      }

      if (q.type === 'buttons') {
        this.#renderButtons(q);
      } else {
        this.#renderToggles(q);
      }
    }

    #renderButtons(q) {
      let html =
        '<p class="custom-ski-finder__step-title">' +
        this.#esc(q.title) +
        '</p>';
      html += '<div class="custom-ski-finder__options">';

      for (const v of q.values) {
        const sel = this.#answers[this.#currentStep] === v.key;
        html +=
          '<button class="custom-ski-finder__option' +
          (sel ? ' custom-ski-finder__option--selected' : '') +
          '" type="button" data-answer="' +
          this.#esc(v.key) +
          '">' +
          this.#esc(v.label) +
          '</button>';
      }

      html += '</div>';
      this.#stepContainer.innerHTML = html;

      for (const btn of this.#stepContainer.querySelectorAll('[data-answer]')) {
        btn.addEventListener('click', () => {
          this.#answers[this.#currentStep] = btn.dataset.answer;
          this.#syncLiveChat();
          this.#renderStep();
        });
      }
    }

    #renderToggles(q) {
      let html =
        '<p class="custom-ski-finder__step-title">' +
        this.#esc(q.title) +
        '</p>';
      html += '<fieldset class="custom-ski-finder__toggles">';

      for (const v of q.values) {
        const sel = this.#answers[this.#currentStep] === v.key;
        html +=
          '<label class="custom-ski-finder__toggle-label">' +
          '<input type="radio" name="step' +
          this.#currentStep +
          '" value="' +
          this.#esc(v.key) +
          '"' +
          (sel ? ' checked' : '') +
          '>' +
          '<span class="custom-ski-finder__toggle-indicator"></span>' +
          '<span>' +
          this.#esc(v.label) +
          '</span>' +
          '</label>';
      }

      html += '</fieldset>';
      this.#stepContainer.innerHTML = html;

      for (const input of this.#stepContainer.querySelectorAll(
        'input[type="radio"]'
      )) {
        input.addEventListener('change', () => {
          this.#answers[this.#currentStep] = input.value;
          this.#syncLiveChat();
          if (this.#nextBtn) this.#nextBtn.disabled = false;
        });
      }
    }

    #renderBioForm() {
      const d = this.#data.bioForm || {};
      const isPortable = this.#mode === 'portable';
      const title = isPortable
        ? d.portableHeadline || "Let's get the fit right"
        : d.headline || 'Anything else you want to share with us?';

      let html =
        '<p class="custom-ski-finder__step-title">' +
        this.#esc(title) +
        '</p>';
      html += '<form class="custom-ski-finder__form">';

      /* Height select */
      html += '<div>';
      html +=
        '<p class="custom-ski-finder__form-hint">' +
        this.#esc(
          d.heightMessage ||
            'For recommended ski length, enter your height & weight'
        ) +
        '</p>';
      html += '<select class="custom-ski-finder__select" name="height">';
      html += '<option value="">Select height</option>';
      for (const h of this.#data.heightOptions || []) {
        const sel = this.#formValues.height === h.value ? ' selected' : '';
        html +=
          '<option value="' +
          h.value +
          '"' +
          sel +
          '>' +
          this.#esc(h.label) +
          '</option>';
      }
      html += '</select></div>';

      /* Weight input */
      html += '<div>';
      html += '<p class="custom-ski-finder__form-hint">&nbsp;</p>';
      html +=
        '<input class="custom-ski-finder__input" type="number" name="weight" placeholder="Weight (Lbs)" min="50" max="325" inputmode="numeric" value="' +
        (this.#formValues.weight || '') +
        '"></div>';

      /* Full mode only: message, email, name */
      if (!isPortable) {
        html +=
          '<div class="custom-ski-finder__form-full">' +
          '<textarea class="custom-ski-finder__textarea" name="message" rows="4" placeholder="Anything else? The more you explain what you\'re looking for, the more accurate our suggestion.">' +
          this.#esc(this.#formValues.message || '') +
          '</textarea></div>';

        html += '<div>';
        html +=
          '<p class="custom-ski-finder__form-hint">' +
          this.#esc(d.emailMessage || '') +
          '</p>';
        html +=
          '<input class="custom-ski-finder__input" type="email" name="email" placeholder="Enter your email address" value="' +
          this.#esc(this.#formValues.email || '') +
          '"></div>';

        html += '<div>';
        html += '<p class="custom-ski-finder__form-hint">&nbsp;</p>';
        html +=
          '<input class="custom-ski-finder__input" type="text" name="name" placeholder="Your Name" value="' +
          this.#esc(this.#formValues.name || '') +
          '"></div>';
      }

      /* Form buttons */
      html +=
        '<div class="custom-ski-finder__form-full custom-ski-finder__nav">';
      html +=
        '<button class="custom-ski-finder__btn custom-ski-finder__btn--back" type="button" data-form-back>Back</button>';
      html +=
        '<button class="custom-ski-finder__btn custom-ski-finder__btn--primary" type="submit">Submit</button>';
      html += '</div>';

      html += '</form>';
      this.#stepContainer.innerHTML = html;

      /* Form event listeners */
      const form = this.#stepContainer.querySelector('form');
      form?.addEventListener('submit', (e) => this.#handleSubmit(e));
      form?.addEventListener('change', (e) => {
        if (!e.target.name) return;
        this.#formValues[e.target.name] = e.target.value;
        this.#calculateSize();
        this.#syncLiveChat();
      });

      const formBack = this.#stepContainer.querySelector('[data-form-back]');
      formBack?.addEventListener('click', () => this.#goBack());
    }

    /* ══════════════════════════════════════
       Form Submission
       ══════════════════════════════════════ */
    #handleSubmit(e) {
      e.preventDefault();
      const fd = new FormData(e.target);

      for (const [key, val] of fd.entries()) {
        this.#formValues[key] = String(val);
      }

      /* Calculate size recommendation */
      this.#calculateSize();

      /* Save to localStorage */
      try {
        localStorage.setItem('finder', JSON.stringify(this.#answers));
        localStorage.setItem('bio', JSON.stringify(this.#formValues));
      } catch { /* noop */ }

      /* Get model recommendations from decision tree */
      this.#recommendation = this.#getRecommendations(this.#answers);

      /* Save recommendations */
      try {
        localStorage.setItem(
          'recommended',
          JSON.stringify(this.#recommendation)
        );
      } catch { /* noop */ }

      this.#syncLiveChat();

      /* Track to Klaviyo */
      this.#trackKlaviyo();

      /* Track to dataLayer */
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: 'Model Recommendation',
          result: this.#recommendation,
        });
      }

      /* Navigate or show results */
      if (this.#mode === 'portable') {
        window.location.href = this.#resultsUrl;
      } else {
        this.#showResults();
      }
    }

    /* ══════════════════════════════════════
       Size Calculation
       Replicates: recommendSize({ weight, height, skills })
       Formula: weightMultiplier + height + skills
       - weight < 100: multiplier = round((100 - weight) / 15)
       - weight > 120: multiplier = round((weight - 120) / 15)
       - weight 100-120: multiplier = 0
       - skills: beginner = -10, intermediate = -5, expert = -2
       ══════════════════════════════════════ */
    #calculateSize() {
      const height = parseInt(this.#formValues.height);
      const weight = parseInt(this.#formValues.weight);

      this.#sizeResult = 0;
      if (!height || !weight) return;

      const ability = this.#answers[0];
      const skills =
        ability === 'beginner' ? -10 : ability === 'intermediate' ? -5 : -2;

      let weightMult = 0;
      if (weight < 100) {
        weightMult = Math.round((100 - weight) / 15);
      } else if (weight > 120) {
        weightMult = Math.round((weight - 120) / 15);
      }

      this.#sizeResult = weightMult + height + skills;

      try {
        localStorage.setItem(
          'skiprefs',
          JSON.stringify({
            weight: weight,
            height: height,
            skills: skills,
            recommended: this.#sizeResult,
          })
        );
      } catch { /* noop */ }
    }

    /* ══════════════════════════════════════
       Decision Tree Traversal
       Walks: results[ability][tricks][feel][powder][binding]
       Returns array of model name strings.
       ══════════════════════════════════════ */
    #getRecommendations(answers) {
      if (!answers || !this.#data.results) return [];

      const keys = Object.keys(answers).sort(
        (a, b) => Number(a) - Number(b)
      );
      let node = this.#data.results;

      for (const k of keys) {
        if (node && typeof node === 'object' && node[answers[k]]) {
          node = node[answers[k]];
        } else {
          return [];
        }
      }

      return Array.isArray(node) ? node : [];
    }

    /* ══════════════════════════════════════
       Show Results (full mode)
       ══════════════════════════════════════ */
    #showResults() {
      if (!this.#resultsView) return;

      /* Hide quiz, show results */
      if (this.#quizView) this.#quizView.hidden = true;
      if (this.#previousBanner) this.#previousBanner.hidden = true;
      this.#resultsView.hidden = false;

      /* Set headlines from data */
      const ctx = this.#data.pageContext?.results || {};
      const headline = this.#resultsView.querySelector(
        '[ref="resultsHeadline"]'
      );
      const desc = this.#resultsView.querySelector(
        '[ref="resultsDescription"]'
      );
      if (headline)
        headline.textContent = ctx.headline || 'Ski Finder Results';
      if (desc) desc.textContent = ctx.description || '';

      /* Size result */
      const sizeEl = this.#resultsView.querySelector('[ref="sizeResult"]');
      if (sizeEl && this.#sizeResult > 0) {
        sizeEl.textContent =
          'Your recommended ski length is ~' + this.#sizeResult + 'cm';
        sizeEl.hidden = false;
      }

      /* Show only model cards that match recommendations */
      const allCards =
        this.#resultsView.querySelectorAll('[data-model-name]');
      for (const card of allCards) {
        const name = card.dataset.modelName;
        card.hidden = !this.#recommendation.includes(name);
      }

      /* Start each set of recommendations at the first visible model. */
      this.#resultsView.querySelector('ski-carousel')?.reset?.();

      /* Scroll to results */
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ══════════════════════════════════════
       Previous Results Banner (portable mode)
       ══════════════════════════════════════ */
    #showPreviousBanner() {
      if (this.#quizView) this.#quizView.hidden = true;
      if (this.#previousBanner) this.#previousBanner.hidden = false;
    }

    /* Send readable answers to the LiveChat visitor details. */
    #syncLiveChat() {
      const keys = ['ability', 'tricks', 'feel', 'powder', 'touring_binding'];
      const variables = {};
      keys.forEach((key, index) => {
        const answer = this.#data.questions[index]?.values.find(
          (value) => value.key === this.#answers[index]
        );
        variables['ski_finder_' + key] = answer?.label || '';
      });
      for (const key of ['height', 'weight', 'name', 'email', 'message']) {
        const value = this.#formValues[key];
        const unit = key === 'height' ? ' cm' : key === 'weight' ? ' lbs' : '';
        variables['ski_finder_' + key] = value ? value + unit : '';
      }
      variables.ski_finder_recommended_models = this.#recommendation.join(', ');
      variables.ski_finder_recommended_length = this.#sizeResult ? this.#sizeResult + ' cm' : '';
      window.jSkisUpdateLiveChatFinder?.(variables);
    }

    /* ══════════════════════════════════════
       Klaviyo Tracking
       Updates the profile with preference_* properties
       (plus email/name when captured via the bio form)
       and fires the "Completed Ski Finder" event carrying
       the enriched recommendations (product id, url, price
       per recommended model). The onsite tracker attaches
       the event to the current profile — identified or
       anonymous (merged on later identification).
       ══════════════════════════════════════ */
    #trackKlaviyo() {
      if (typeof window.klaviyo === 'undefined') return;

      const feel = this.#answers[2];
      const powder = this.#answers[3];
      const binding = this.#answers[4];

      const preferenceProps = {
        preference_ability: this.#answers[0],
        preference_jumps_or_turns: this.#answers[1] === 'yes' ? 'jumps' : 'carve',
        preference_feel: feel,
        preference_flex: feel ? feel.charAt(0).toUpperCase() + feel.slice(1) : undefined,
        preference_powder: powder,
        preference_time_in_powder: powder,
        preference_binding: binding,
        preference_method: binding,
        preference_height: parseInt(this.#formValues.height, 10) || undefined,
        preference_ski_length: this.#sizeResult || undefined,
        preference_ideal_skis: this.#recommendation[0] || undefined,
      };

      /* Identify — attaches preferences (and email/name when captured)
         to the profile so the event lands on a known profile. */
      if (this.#formValues.email) {
        window.klaviyo.push([
          'identify',
          {
            $email: this.#formValues.email,
            $first_name: this.#formValues.name || undefined,
            ...preferenceProps,
          },
        ]);
      } else {
        window.klaviyo.push(['identify', preferenceProps]);
      }

      /* Map answer indices to readable keys */
      const keyMap = ['Ability', 'Tricks', 'Feel/Flex', 'Surface', 'Binding'];
      const mapped = {};
      for (const [k, v] of Object.entries(this.#answers)) {
        mapped[keyMap[Number(k)] || k] = v;
      }

      /* Enrich each recommended model with its product details */
      const recommendations = this.#buildRecommendations();

      const payload = {
        ...mapped,
        ...this.#formValues,
        recommended_models: this.#recommendation,
        recommendations,
        recommended_product_ids: recommendations.flatMap((r) =>
          r.products.map((p) => p.id)
        ),
        recommended_size: this.#sizeResult || null,
      };

      window.klaviyo.push(['track', 'Completed Ski Finder', payload]);
    }

    /* ══════════════════════════════════════
       Build recommendation objects from the
       model -> products lookup emitted in Liquid.
       Returns [{ model, products: [{ id, title, handle, url, price }] }]
       ══════════════════════════════════════ */
    #buildRecommendations() {
      if (this.#modelProducts === undefined) {
        const el = this.querySelector('[ref="modelProducts"]');
        try {
          this.#modelProducts = el ? JSON.parse(el.textContent) : {};
        } catch {
          this.#modelProducts = {};
        }
      }

      return this.#recommendation.map((name) => ({
        model: name,
        products: (this.#modelProducts[name] || []).map((p) => ({
          id: p.id,
          title: p.title,
          handle: p.handle,
          url: p.url,
          price: p.price,
        })),
      }));
    }

    /* ══════════════════════════════════════
       Utility
       ══════════════════════════════════════ */
    #esc(str) {
      const el = document.createElement('span');
      el.textContent = str || '';
      return el.innerHTML;
    }
  }

  if (!customElements.get('ski-finder')) {
    customElements.define('ski-finder', SkiFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metafield-gallery"] && !Shopify.designMode) return;
  try {
    
  class MetafieldGallery extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('auto-height')) return;

      this.#slidesContainer = this.querySelector('slideshow-slides');
      this.#slides = Array.from(this.querySelectorAll('slideshow-slide'));
      if (!this.#slidesContainer || this.#slides.length === 0) return;

      this.#slides.forEach((slide) => this.#trackMedia(slide));
      this.#applyAspect(this.#slides[0]);

      this.#observer = new IntersectionObserver(
        (entries) => {
          let bestEntry = null;
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
              bestEntry = entry;
            }
          }
          if (bestEntry) this.#applyAspect(bestEntry.target);
        },
        { root: this.#slidesContainer, threshold: [0.5, 0.75, 1] }
      );
      this.#slides.forEach((slide) => this.#observer.observe(slide));
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    #trackMedia(slide) {
      const media = slide.querySelector('img, video');
      if (!media) return;
      const setFromMedia = () => {
        const w = media.naturalWidth || media.videoWidth || parseInt(media.getAttribute('width'), 10);
        const h = media.naturalHeight || media.videoHeight || parseInt(media.getAttribute('height'), 10);
        if (w > 0 && h > 0) {
          slide.dataset.aspectRatio = w / h;
          if (slide === this.#currentSlide) this.#applyAspect(slide);
        }
      };
      const wAttr = parseInt(media.getAttribute('width'), 10);
      const hAttr = parseInt(media.getAttribute('height'), 10);
      if (wAttr > 0 && hAttr > 0) slide.dataset.aspectRatio = wAttr / hAttr;
      if (media.tagName === 'IMG') {
        if (media.complete) setFromMedia();
        else media.addEventListener('load', setFromMedia, { once: true });
      } else {
        media.addEventListener('loadedmetadata', setFromMedia, { once: true });
      }
    }

    #applyAspect(slide) {
      this.#currentSlide = slide;
      const aspect = slide.dataset.aspectRatio;
      if (aspect) this.#slidesContainer.style.setProperty('--current-slide-aspect', aspect);
    }

    #slidesContainer;
    #slides;
    #observer;
    #currentSlide;
  }

  if (!customElements.get('metafield-gallery')) {
    customElements.define('metafield-gallery', MetafieldGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ski-model-construction"] && !Shopify.designMode) return;
  try {
    
  class ConstructionOverlay extends HTMLElement {
    connectedCallback() {
      this.#overlay = this.querySelector('[ref="overlayImage"]');
      if (!this.#overlay) return;

      const singleMaterial = this.querySelector('.custom-construction__slide-content--single');
      if (singleMaterial) {
        this.#showOverlay(singleMaterial);
        return;
      }

      const slideshow = this.querySelector('.custom-construction__slideshow');
      if (!slideshow) return;

      this.#syncToActiveSlide(slideshow);

      // Swap the base/overlay construction image whenever a new material slide
      // becomes active. This only touches the overlay <img>, never the slideshow
      // layout — so the carousel scrolls with the theme's stock behavior.
      this.#observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.attributeName === 'aria-hidden' &&
            mutation.target.getAttribute('aria-hidden') === 'false'
          ) {
            const content = mutation.target.querySelector('.custom-construction__slide-content');
            this.#showOverlay(content);
            break;
          }
        }
      });

      this.#observer.observe(slideshow, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        subtree: true,
      });
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    #syncToActiveSlide(slideshow) {
      customElements.whenDefined('slideshow-component').then(() => {
        requestAnimationFrame(() => {
          const active = slideshow.querySelector('slideshow-slide[aria-hidden="false"]');
          if (active) {
            this.#showOverlay(active.querySelector('.custom-construction__slide-content'));
          }
        });
      });
    }

    #showOverlay(slideContent) {
      if (!slideContent || !this.#overlay) return;

      const src = slideContent.getAttribute('data-overlay-src');
      const alt = slideContent.getAttribute('data-overlay-alt');

      if (src) {
        this.#overlay.src = src;
        this.#overlay.alt = alt || '';
        this.#overlay.classList.add('custom-construction__overlay-image--visible');
      } else {
        this.#overlay.classList.remove('custom-construction__overlay-image--visible');
      }
    }

    #overlay;
    #observer;
  }

  if (!customElements.get('construction-overlay')) {
    customElements.define('construction-overlay', ConstructionOverlay);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ski-model-specs"] && !Shopify.designMode) return;
  try {
    
  class SpecsTable extends HTMLElement {
    connectedCallback() {
      this.#tableContainer = this.querySelector('[ref="tableContainer"]');
      this.#tableWrapper = this.querySelector('[ref="tableWrapper"]');
      this.#toggleButton = this.querySelector('[ref="toggleButton"]');

      if (this.#toggleButton && this.#tableContainer) {
        this.#tableContainer.classList.add('custom-specs__table-container--collapsed');
        this.#toggleButton.setAttribute('aria-expanded', 'false');
        this.#toggleButton.addEventListener('click', () => this.#handleToggle());
      }

      if (this.#tableWrapper) {
        this.#tableWrapper.addEventListener('scroll', () => this.#handleScroll(), { passive: true });
        this.#handleScroll();
      }
    }

    #handleToggle() {
      const isCollapsed = this.#tableContainer.classList.toggle('custom-specs__table-container--collapsed');
      this.#toggleButton.setAttribute('aria-expanded', String(!isCollapsed));
    }

    #handleScroll() {
      const { scrollLeft, scrollWidth, clientWidth } = this.#tableWrapper;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
      this.#tableWrapper.classList.toggle('custom-specs__table-wrapper--scrolled-end', atEnd);
    }

    #tableContainer;
    #tableWrapper;
    #toggleButton;
  }

  if (!customElements.get('specs-table')) {
    customElements.define('specs-table', SpecsTable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ski-models-metafield-grid"] && !Shopify.designMode) return;
  try {
    
  class SkiGridCarousel extends HTMLElement {
    connectedCallback() {
      this.#scroll = this.querySelector('[ref="scrollContainer"]');
      this.#prevBtn = this.querySelector('[ref="prevBtn"]');
      this.#nextBtn = this.querySelector('[ref="nextBtn"]');

      if (!this.#scroll) return;

      this.#prevBtn?.addEventListener('click', () => this.#navigate(-1));
      this.#nextBtn?.addEventListener('click', () => this.#navigate(1));
      this.#scroll.addEventListener('scroll', () => this.#updateArrows(), { passive: true });

      this.#resizeObserver = new ResizeObserver(() => this.#updateArrows());
      this.#resizeObserver.observe(this.#scroll);

      this.#updateArrows();
    }

    disconnectedCallback() {
      this.#resizeObserver?.disconnect();
    }

    #navigate(direction) {
      const list = this.#scroll.firstElementChild;
      const cards = list ? list.children : [];
      if (!cards.length) return;

      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(list).gap) || 16;
      const scrollAmount = (cardWidth + gap) * direction;

      this.#scroll.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    #updateArrows() {
      if (!this.#scroll || !this.#prevBtn || !this.#nextBtn) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.#scroll;
      const canScroll = scrollWidth > clientWidth + 1;

      if (!canScroll) {
        this.#prevBtn.hidden = true;
        this.#nextBtn.hidden = true;
        return;
      }

      this.#prevBtn.hidden = scrollLeft <= 1;
      this.#nextBtn.hidden = scrollLeft + clientWidth >= scrollWidth - 1;
    }

    #scroll;
    #prevBtn;
    #nextBtn;
    #resizeObserver;
  }

  if (!customElements.get('ski-grid-carousel')) {
    customElements.define('ski-grid-carousel', SkiGridCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
